import { createLocalProfile, migrateProfile, type LocalProfile } from '../domain/profile';

export interface Persistence {
  load(): LocalProfile;
  save(profile: LocalProfile): void;
  clear(): void;
}

const STORAGE_KEY = 'style.profile.v2';
const LEGACY_STORAGE_KEY = 'style.profile.v1';
const COPY_CACHE_PREFIX = 'style.recommendation-copy.';

export class LocalStoragePersistence implements Persistence {
  load(): LocalProfile {
    try {
      const raw =
        window.localStorage.getItem(STORAGE_KEY) ?? window.localStorage.getItem(LEGACY_STORAGE_KEY);
      return raw ? migrateProfile(JSON.parse(raw)) : createLocalProfile();
    } catch {
      return createLocalProfile();
    }
  }

  save(profile: LocalProfile) {
    const serialised = JSON.stringify({ ...profile, updatedAt: new Date().toISOString() });
    // Image data is never part of LocalProfile; guard against accidental data URLs as defense in depth.
    if (serialised.includes('data:image/')) throw new Error('Image payloads cannot be persisted.');
    window.localStorage.setItem(STORAGE_KEY, serialised);
  }

  clear() {
    window.localStorage.removeItem(STORAGE_KEY);
    window.localStorage.removeItem(LEGACY_STORAGE_KEY);
    for (let index = window.localStorage.length - 1; index >= 0; index -= 1) {
      const key = window.localStorage.key(index);
      if (key?.startsWith(COPY_CACHE_PREFIX)) window.localStorage.removeItem(key);
    }
  }
}

export const persistence = new LocalStoragePersistence();
